import { render } from "./toastAlert.vue?vue&type=template&id=4acdd55b&scoped=true"
import script from "./toastAlert.vue?vue&type=script&lang=js"
export * from "./toastAlert.vue?vue&type=script&lang=js"

import "./toastAlert.vue?vue&type=style&index=0&id=4acdd55b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acdd55b"]])

export default __exports__